module.exports = __webpack_public_path__ + "static/media/599.7554 (3).0396d3e9.pdf";